module.exports = __webpack_public_path__ + "img/Program block.d0f67818.png";